var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-skeleton-loader',{staticClass:"mb-4",attrs:{"height":"14","max-width":"180","type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }